angular.module('empower.uploadDocument', ['blueimp.fileupload'])
.config([
            '$routeProvider', '$httpProvider', 'fileUploadProvider',
            function ($routeProvider, $httpProvider, fileUploadProvider) {
                delete $httpProvider.defaults.headers.common['X-Requested-With'];
                    // Demo settings:
                    angular.extend(fileUploadProvider.defaults, {
                        // Enable image resizing, except for Android and Opera,
                        // which actually support image resizing, but fail to
                        // send Blob objects via XHR requests:
                        disableImageResize: /Android(?!.*Chrome)|Opera/
                            .test(window.navigator.userAgent),
                        //maxFileSize: 7340032, //~7MB
                        maxNumberOfFiles: 2,
                        acceptFileTypes: /(\.|\/)(pdf|doc|docx|xls|xlsx||gif|tiff|jpe?g|png|bmp)$/i 
                    });
                $routeProvider
                    .when('/upload-document', {
                        templateUrl: 'module/uploadDocument/view/upload-document.html',
                        controller: 'uploadDocumentController'
                    });
            }
        ]);